// extracted by css-extract-rspack-plugin
export default {"cls1":"TasteOfMentionsUpsellModal-cls1_15T","cls2":"TasteOfMentionsUpsellModal-cls2_8Bi TasteOfMentionsUpsellModal-cls1_15T"};